/**
 * What a production bundle built without its Entra settings shows: the shell
 * with the application's name, and one sentence saying why nothing else is
 * there. No navigation, no sign-in button and no screen, because each of those
 * would invite someone to use a planner that cannot tell who they are.
 */
import { AppShell, EmptyState } from "@depicomnlbv/platform-ui";

import { APP_NAME } from "../appName";

export function NotConfigured({ sentence }: { sentence: string }) {
  return (
    <AppShell appName={APP_NAME}>
      <div className="screen">
        <EmptyState>{sentence}</EmptyState>
      </div>
    </AppShell>
  );
}
